import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_ackkgbehbu: FaireCollectionEntity = {
  token: "pbc_ackkgbehbu",
  type: "collection",
  name: "Fruits & Veggies Organic Baby Collection--Spring/Summer",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f2841868a87f469db183abccea286080b5b4800508c9646f8c881616b94ca780.jpeg",
  itemCount: 49,
  description:
    "Charming fruits & veggies-themed apparel, blankets, and toys for Spring/Summer—ethically crafted with organic cotton grown by small farmers in India.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:20.522Z",
    importedBy: "entity-db-import-collections",
  },
};
